"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.format = void 0;
var _dateFns = require("date-fns");
var _dateFnsTz = require("date-fns-tz");
// we are using format from date-fns-tz instead of date-fns to support time zones
const format = (date, formatString, options) => {
  return (0, _dateFnsTz.format)(date, formatString, {
    // date-fns-tz does not take advantage of setDefaultOptions() from date-fns, so we need to pass defaults ourselves
    // this enables consumers to call setDefaultOptions() and have those options applied to future format() calls
    ...(0, _dateFns.getDefaultOptions)(),
    ...options
  });
};
exports.format = format;